import React, { useState } from "react";
import AddItemToPlaylistDialog from "./AddItemToPlaylistDialog";
import TranslatedText from "@components/items/display/TranslatedText";
import { DialogTrigger } from "@ui/dialog";

const EmptyPlaylist = () => {
  const [isAddItemDialogOpen, setIsAddItemDialogOpen] =
    useState<boolean>(false);

  return (
    <div className="flex h-1/2 w-full flex-col items-center justify-center gap-4">
      <TranslatedText
        text={`my-library.${"your playlist is empty"}`}
        className="text-[20px] font-medium dark:text-white"
      />
      <AddItemToPlaylistDialog
        open={isAddItemDialogOpen}
        setOpen={setIsAddItemDialogOpen}
        trigger={
          <DialogTrigger className="flex items-center justify-center rounded-xl bg-primary p-3 text-[15px] font-medium text-white hover:opacity-80">
            <TranslatedText
              text={`my-library.${"collect youre favorite titles"}`}
            />
          </DialogTrigger>
        }
      />
    </div>
  );
};

export default EmptyPlaylist;
